
function mh_filter(){
    if($('#category-filter-hover').length>0){
        $('.filter-section-boolean').appendTo('#category-filter-hover')
        $('.slider-wrapper').addClass('filter-section').wrapInner('<div class="priceFilter"></div>').appendTo('#category-filter-hover');
    }
    else{
       $('.filter-sections').append('<div id="category-filter-hover"></div>')
        $('.filter-section-boolean').appendTo('#category-filter-hover')
        $('.slider-wrapper').addClass('filter-section').wrapInner('<div class="priceFilter"></div>').appendTo('#category-filter-hover');
    }
    $('.filter-section-boolean').prepend('<h4><span>Příznaky</span></h4>')
    $('.slider-wrapper h4').insertBefore('.priceFilter');
    $('.filter-section h4').click(function(){
        $(this).closest('.filter-section').toggleClass('openFilter');
        $('.filter-section').not($(this).closest('.filter-section')).removeClass('openFilter')    
    });
    $('.filter-section').each(function(){
        $(this).find('label').each(function(){
            if($(this).hasClass('disabled')){
                $(this).closest('div').attr('data-disabled', 'disabled')
            }
        })
        $(this).find('fieldset label').prepend('<span class="nadpis">'+$(this).find('h4').text()+': </span>')
    })
    if($('.vybrane-filtry').length == 0) { 
            $('<div class="vybrane-filtry"></div>').insertAfter("#category-header"); 
            $(".filter-label.active").clone().appendTo(".vybrane-filtry");
            $(".vybrane-filtry .filter-label.active").closest("div").addClass("aktivni-filtr"); 
            $(".vybrane-filtry .filter-section fieldset div:not(.aktivni-filtr)").remove(); 
            $('#clear-filters').clone().appendTo('.vybrane-filtry');
            $('#clear-filters').on('click', function(){
                $('body').removeClass('cena-yes')
            });
          
    }

}

$(document).ready(function() { 
    mh_filter(); 
  
});  
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mh_filter();
 
}); 